import { type DateOrMoment, formatters } from '@utils/intl/dateTimeFormatters'

export function startEndFormatter(scheduleType: string, value: DateOrMoment | null, timezone: string): string {
  if (scheduleType === 'event') {
    return !value ? 'Forever' : (formatters.DATE_TIME(value, timezone) ?? '')
  }
  return !value ? 'Forever' : formatters.DATE(value, timezone)
}
